import logos from './airlineLogos';

interface Props {
    airlineCode: string;
    className?: string;
}

export const AirlineLogo = ({ airlineCode, className }: Props) => {
    const logoAttributes = logos()[airlineCode?.toLowerCase()];

    return logoAttributes ? (
        <img
            src={logoAttributes.src}
            height={logoAttributes.height}
            width={logoAttributes.width}
            loading={'lazy'}
            className={className}
            alt=""
        />
    ) : (
        <span>&nbsp;</span> // Need a space to force it to occupy a column in the grid
    );
};
